/** DigixLeads UI state keys that should not persist across sessions. */
import { clearAuthStorageKeys } from "./authStorage";

const DIGIX_LEADS_STORAGE_PREFIXES = [
  "digixLeads",
  "digixiLeads",
];

function removeMatchingKeys(storage, prefixes) {
  if (!storage) return;
  const keysToRemove = [];
  for (let i = 0; i < storage.length; i += 1) {
    const key = storage.key(i);
    if (!key) continue;
    if (prefixes.some((prefix) => key.startsWith(prefix))) {
      keysToRemove.push(key);
    }
  }
  keysToRemove.forEach((key) => storage.removeItem(key));
}

/**
 * Clear DigixLeads filters/page state from localStorage and sessionStorage.
 */
export function clearDigixLeadsStorage() {
  removeMatchingKeys(localStorage, DIGIX_LEADS_STORAGE_PREFIXES);
  removeMatchingKeys(sessionStorage, DIGIX_LEADS_STORAGE_PREFIXES);
}

/**
 * Clear auth + DigixLeads UI state used on logout.
 */
export function clearAuthSessionStorage() {
  clearAuthStorageKeys();
  clearDigixLeadsStorage();
}
